import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";

// Public Pages
import Home from "@/pages/Home";
import Request from "@/pages/Request";
import ThankYou from "@/pages/ThankYou";
import FAQ from "@/pages/FAQ";
import Pledge from "@/pages/Pledge";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Donate from "@/pages/Donate";

// Admin Pages
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/request" element={<Request />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/pledge" element={<Pledge />} />
            <Route path="/privacy" element={<Pledge />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: 'var(--pws-off)',
            border: '1px solid var(--pws-line)',
            color: 'var(--pws-charcoal)',
          },
        }}
      />
    </div>
  );
}

export default App;
